import { UntilDestroy } from '@ngneat/until-destroy';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { JFSEService } from '@services/jfse';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';

@UntilDestroy()
@Component({
    selector: 'app-how-to-install',
    templateUrl: './how-install.component.html',
    styleUrls: ['./how-install.component.scss'],
})
export class HowInstallComponent {
    constructor(
        private readonly modalRef: BsModalRef,
        private readonly jfseService: JFSEService,
        public readonly translateService: TranslateService,
        private readonly clipboard: Clipboard,
    ) {}

    close() {
        this.modalRef.hide();
    }

    downloadWindows() {
        return this.jfseService.downloadWindowsClient();
    }

    downloadApple() {
        return this.jfseService.downloadAppleClient();
    }

    public readonly environment = environment;

    openDaemonConfigPanel() {
        window.open(environment.jfse.daemonConfigPanelUrl, '_blank');
    }

    copyToClipBoard(content) {
        this.clipboard.copy(content);
    }
}
